export const NEW_PASSWORD_REQUIRED = 'NEW_PASSWORD_REQUIRED';
export const COGNITO_USER = Symbol('Cognito User');
